import { render, staticRenderFns } from "./AssignTodoItem.vue?vue&type=template&id=05ab954b"
import script from "./AssignTodoItem.vue?vue&type=script&lang=js"
export * from "./AssignTodoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports